import { CONTACT, WA_MESSAGES } from "@/lib/brand";
import { MessageCircle } from "lucide-react";
import { useState } from "react";

export default function FloatingWhatsApp() {
  const [expanded, setExpanded] = useState(false);
  const href = `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(
    WA_MESSAGES.floating,
  )}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      onMouseEnter={() => setExpanded(true)}
      onMouseLeave={() => setExpanded(false)}
      className="fixed z-50 bottom-24 right-6 flex items-center gap-3 sb-pulse bg-[#25D366] hover:bg-[#1eb857] text-white rounded-full pl-4 pr-5 py-3 shadow-2xl transition-all"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={22} strokeWidth={2} />
      <span
        className={`overflow-hidden whitespace-nowrap font-semibold text-sm transition-all ${
          expanded ? "max-w-[220px] opacity-100" : "max-w-0 opacity-0"
        }`}
      >
        Chat with us
      </span>
    </a>
  );
}
